import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_IRC_AUTONOMOUS_PARAMETERS_REQUEST,
  FETCH_IRC_AUTONOMOUS_PARAMETERS_SUCCESS,
  FETCH_IRC_AUTONOMOUS_PARAMETERS_ERROR,
  SAVE_IRC_AUTONOMOUS_PARAMETERS_REQUEST,
  SAVE_IRC_AUTONOMOUS_PARAMETERS_SUCCESS,
  SAVE_IRC_AUTONOMOUS_PARAMETERS_ERROR,
} from 'actionTypes'


// GET
export const fetchRequest = (token) => (dispatch) => {
  dispatch(fetchParametersRequest())

  return new Api(token, dispatch)
    .get(API_URL.MENU_IRC_AUTONOMOUS_GET)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(fetchRequestSuccess(response.data))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchRequestError(error))
      dispatch(hideSpinner())
    })
}

export const fetchParametersRequest = () => ({
  type: FETCH_IRC_AUTONOMOUS_PARAMETERS_REQUEST,
})

export const fetchRequestSuccess = (data) => {
  const allParameters = applyDoubleInMoney(data)
  return {
    type: FETCH_IRC_AUTONOMOUS_PARAMETERS_SUCCESS,
    payload: allParameters,
  }
}

export const fetchRequestError = (error) => ({
  type: FETCH_IRC_AUTONOMOUS_PARAMETERS_ERROR,
  payload: error,
})

// UPDATE
export const updateParameters = (token, data) => (dispatch) => {
  dispatch(updateParametersRequest())
 
  // const data = applyDoubleInMoney(data)

  return new Api(token, dispatch)
    .post(API_URL.MENU_IRC_AUTONOMOUS_SAVE, {
      ...data,
      cdLdap: data.cdLdap,
      dsLdap : data.dsLdap,
      idIrcAutonomousParameter: null,
    })
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(updateParametersSuccess(response.data))
      dispatch(hideSpinner())
      return response
    })
    .catch((error) => {
      dispatch(updateParametersError(error.fields))
      dispatch(hideSpinner())
      return error.fields
    })
}

export const updateParametersRequest = () => ({
  type: SAVE_IRC_AUTONOMOUS_PARAMETERS_REQUEST,
})

export const updateParametersSuccess = (data) => ({
  type: SAVE_IRC_AUTONOMOUS_PARAMETERS_SUCCESS,
  payload: applyDoubleInMoney(data),
})

export const updateParametersError = (error) => ({
  type: SAVE_IRC_AUTONOMOUS_PARAMETERS_ERROR,
  payload: error,
})

const applyDoubleInMoney = (data) => {
  const moneyFields = ['valueLimit']

  moneyFields.forEach((field) => {
    if (data[field]) {
      data[field] = Number(data[field]).toFixed(2)
    }
  })

  const allParameters = {
    tsCreated: data.tsCreated,
    cdLdap: data.cdLdap,
    dsLdap: data.dsLdap,
    qqChanges: data.qqChanges,
    qqDay: data.qqDay,
    qqStockLimit: data.qqStockLimit,
    valueLimit: data.valueLimit,
  }

  return allParameters
}
